import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FlexStack } from '~/components/atomic';
import InputHeightContainer from '../InputHeightContainer';
import { Choices } from './Choices';

interface ChoicesListProps {
  setUserChoice: React.Dispatch<React.SetStateAction<Choices | null>>;
}

export default function ChoicesList({ setUserChoice }: ChoicesListProps) {
  return (
    <>
      <Inner spacing={8}>
        <Button onClick={() => setUserChoice('ShutDown')}>
          <span>Shut down your system</span>
        </Button>
        <Button onClick={() => setUserChoice('StayActive')}>
          <span>No, ARIA. Stay active.</span>
        </Button>
      </Inner>
      <InputHeightContainer />
    </>
  );
}

export const Inner = styled(FlexStack)`
  margin: 0 8px 0;
`;

export const Button = styled.button`
  ${({ theme }) => css`
    display: block;
    width: 100%;
    height: 54px;
    transition: 0.3s ease-in-out;
    border: 1px solid ${theme.stroke.stroke_1};
    border-radius: 8px;
    background: ${theme.backgroundColor.bg_dark_5_alpha};
    backdrop-filter: blur(50px);
    cursor: pointer;

    & > span {
      display: block;
      ${theme.fontStyle.text.body16_medium}
      transition: color 0.3s ease-in-out;
      color: ${theme.content.content_light_1};
    }

    &:hover {
      border: 1px solid ${theme.themeColor.main_1};

      & > span {
        color: ${theme.themeColor.main_1};
      }
    }
  `}
`;
